import React, { Component } from "react";
import ReportTableHeader from "./../ReportTableHeader";
import ReportTablePivot from "./../ReportTablePivot";
import { Scrollbars } from "react-custom-scrollbars-2";
import styles from "./../reportTable.module.scss";

const rowStyles = [styles.reportTableRow, styles.reportTableRowBackground];

class ReportConsolidatedTable extends Component {
  getRowCell(item, key) {
    return (
      <div key={key} className={styles.reportTableRowItem} style={{ width: item.width + "px", border: "none" }}>
        <span style={{ border: "none" }}>{item.value}</span>
      </div>
    );
  }

  getRows(units) {
    let rowStyle = rowStyles[1];

    return units.map((unit, index) => {
      rowStyle = rowStyle === rowStyles[0] ? rowStyles[1] : rowStyles[0];

      if (unit.tableData.days.length === 0) return null;

      const row = unit.tableData.days[0].rows[0].data;
      const key = index + unit.data.info.id;

      return (
        <div className={styles.reportTableRowCursor} key={key}>
          <div className={rowStyle}>
            {row.map((item, column) => {
              return this.getRowCell(item, key + column);
            })}
          </div>
        </div>
      );
    });
  }

  render() {
    const { data, height = 450 } = this.props;

    return (
      <div className={styles.reportTableContainer}>
        <Scrollbars style={{ height: height + "px" }} autoHide={false}>
          <ReportTableHeader header={data.units[0].tableData.header} withScroll={false} />
          {this.getRows(data.units)}
          <ReportTablePivot pivot={data.pivot} />
        </Scrollbars>
      </div>
    );
  }
}

export default React.memo(ReportConsolidatedTable);
